// extracted by mini-css-extract-plugin
module.exports = {"container":"CourseAlreadyEnrolled_container__1psBi","msg":"CourseAlreadyEnrolled_msg__1WtvS","backBtn":"CourseAlreadyEnrolled_backBtn__3z8Fy"};